'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _uploads = require('helpers/uploads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var dropboxImg = require('assets/dropbox-icon.png');

var DropboxPicker = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DropboxPicker, _Component);

  function DropboxPicker() {
    (0, _classCallCheck3.default)(this, DropboxPicker);
    return (0, _possibleConstructorReturn3.default)(this, (DropboxPicker.__proto__ || (0, _getPrototypeOf2.default)(DropboxPicker)).apply(this, arguments));
  }

  (0, _createClass3.default)(DropboxPicker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _get3.default)(DropboxPicker.prototype.__proto__ || (0, _getPrototypeOf2.default)(DropboxPicker.prototype), 'componentDidMount', this).call(this, this.initDropbox);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.Dropbox = null;
    }
  }, {
    key: 'onSelect',
    value: function onSelect(files) {
      var onSelect = this.props.onSelect;


      if (onSelect) {
        var _config$app$dropbox = _config2.default.app.dropbox,
            serviceName = _config$app$dropbox.serviceName,
            fileFields = _config$app$dropbox.fileFields;

        var formattedList = (0, _uploads.formatCloudFilesList)(files, serviceName, fileFields);
        onSelect(formattedList);
      }
    }
  }, {
    key: 'initDropbox',
    value: function initDropbox() {
      if (!this.Dropbox) {
        this.Dropbox = require('utils/dropbox-dropins').dropbox();
      }

      if (this.Dropbox) {
        this.Dropbox.appKey = _config2.default.app.dropbox.appKey;
      }
    }
  }, {
    key: 'openDropbox',
    value: function openDropbox() {
      var options = {
        success: this.onSelect,
        multiselect: true,
        linkType: 'direct',
        extensions: (0, _uploads.getUploaderAcceptableFormats)('audio').split(', ')
      };

      this.Dropbox.choose(options);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        { type: 'button', className: 'btn btn-clear', onClick: this.openDropbox, title: 'Dropbox' },
        _react2.default.createElement('img', { src: dropboxImg, alt: '' })
      );
    }
  }]);
  return DropboxPicker;
}(_ClientSideComponent2.default), _class2.propTypes = {
  onSelect: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onSelect', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onSelect'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initDropbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openDropbox', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'openDropbox'), _class.prototype)), _class);
exports.default = DropboxPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Dropbox/DropboxPicker.js
// module id = 1989
// module chunks = 1